import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../services/modal.service';
import { ButtonComponent } from '../button/button.component';
import { FADE_IN_OUT, SLIDE_IN_OUT } from '../../animations/animations';
import { StoreService } from '../../../store/store.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  animations: [
    FADE_IN_OUT(),
    SLIDE_IN_OUT({ right: '0', opacity: 0 }, { right: '35px', opacity: 1 }, { right: '0', opacity: 0 }),
  ],
})
export class ToastComponent {
  constructor(
    public modalSvc: ModalService,
    public storeSvc: StoreService
  ) {}
}
